global.$ = global.jQuery = require('jquery'); // for jquery in views

import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';

$(document).ready(function() {

    // Init datetimepicker instance's
    flatpickr(".flatpickr-input-date", {

    });


    $("#reset_form").click(function () {
        document.getElementById('decisions_form').reset();
        $("#s_date").val("");
        $("#s_from_date").val("");
        $("#s_to_date").val("");

        document.getElementById('decisions_form').submit();
    });

});
